<template>
  <div id="topfootthree">
    <div class="main">
      <div class="title">
        <img src="@/assets/img/topfoottwo_img_log.png" alt="">
        <div>
          <h4>教师资格考试题库</h4>
          <p>育德园师客户端</p>
        </div>
      </div>
      <ul>
        <router-link :to="{name: 'ExamBank'}">
          <li>
            <i></i>
            <h5>模拟试题</h5>
            <p>91689试题</p>
          </li>
        </router-link>
        <router-link :to="{name: 'ExamBank'}">
          <li>
            <i></i>
            <h5>章节练习</h5>
            <p>4114题</p>
          </li>
        </router-link>
        <router-link :to="{name: 'ExamBank'}">
          <li>
            <i></i>
            <h5>历年考题</h5>
            <p>91689试题</p>
          </li>
        </router-link>
        <router-link :to="{name: 'ExamBank'}">
          <li>
            <i></i>
            <h5>每日一练</h5>
            <p>4114试题</p>
          </li>
        </router-link>
      </ul>
      <router-link :to="{name: 'AppDown'}" class="setup">一键安装做题</router-link>
      <div class="qq">
        <div class="left">
          <h6>qq群：723236610</h6>
          <p>加入QQ群一起来考证</p>
        </div>
        <a class="right" href="https://jq.qq.com/?_wv=1027&k=5a5dCcU">一键加群</a>
      </div>
    </div>
    <nav>
      <div class="main">
        <router-link :to="{name: 'PwdLogin', query: {backto: 'Index'}}">学习登录</router-link>
        <a href="tel:4006255668">联系我们</a>
      </div>
    </nav>
    <div class="copyright">
      <p>
        COPYRIGHT © 2005-2024 教师资格证考试版权 <br>
        所有：育德园师
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'topFootThree'
}
</script>

<style scoped lang="stylus">
#topfootthree
  > .main
    width: 7.5rem
    height: 8.88rem
    position: relative
    left: -.2rem
    background: url(../../../assets/img/topfoottwo_img_bg.png) no-repeat center bottom #fff
    -webkit-background-size: 7.5rem 4.6rem
    background-size: 7.5rem 4.6rem
    overflow: hidden
    margin-top: .2rem
    .title
      display: flex
      width: 4.5rem
      height: 1.68rem
      margin: .3rem auto 0
      img
        width: 1.49rem
        height: 1.73rem
      h4
        margin: .2rem .1rem .1rem
        font-size: .32rem
        color: #333
        font-weight: 700
      p
        margin: .1rem
        font-size: .2812rem
        color: #666
    ul
      display: flex
      justify-content: space-between
      align-content: space-between
      flex-wrap: wrap
      width: 6.7rem
      height: 3rem
      margin: 0 auto
      li
        position: relative
        width: 3.16rem
        height: 1.3rem
        border: .02rem solid #f2f2f2
        padding: 0 0 0 .9rem
        -webkit-border-radius: .1rem
        -moz-border-radius: .1rem
        border-radius: .1rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        i
          position: absolute
          top: .28rem
          left: .45rem
          display: block
          width: .75rem
          height: .75rem
          background: url(../../../assets/icon/topfoottwo_icon_bank1.png) no-repeat center #f3f3f6
          -webkit-background-size: .36rem
          background-size: .36rem
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
        h5
          padding: 0
          margin: .3rem 0 0
          font-size: .3rem
          color: #333
          text-align: center
        p
          font-size: .24rem
          color: #999
          text-align: center
      a:nth-of-type(2) li i
        background-image: url(../../../assets/icon/topfoottwo_icon_bank2.png)
        -webkit-background-size: .31rem .37rem
        background-size: .31rem .37rem
      a:nth-of-type(3) li i
        background-image: url(../../../assets/icon/topfoottwo_icon_bank3.png)
        -webkit-background-size: .32rem .36rem
        background-size: .32rem .36rem
      a:nth-of-type(4) li i
        background-image: url(../../../assets/icon/topfoottwo_icon_bank4.png)
        -webkit-background-size: .37rem .34rem
        background-size: .37rem .34rem
    ul + a.setup
      display: block
      width: 5.9rem
      height: .9rem
      line-height: .9rem
      background-color: #ff4b25
      margin: .4rem auto
      font-size: .32rem
      color: #fff
      font-weight: 700
      text-align: center
      -webkit-border-radius: .5rem
      -moz-border-radius: .5rem
      border-radius: .5rem
    .qq
      display: flex
      justify-content: space-between
      align-items: center
      width: 6.7rem
      height: 1.4rem
      border-top: .02rem solid #c5cbd0
      margin: 0 auto
      .left
        position: relative
        width: 3.4rem
        height: .75rem
        padding: 0 0 0 .8rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        &::before
          content: ""
          position: absolute
          top: .05rem
          left: 0
          display: block
          width: .64rem
          height: .64rem
          border: .02rem solid #e2ecf4
          background: url(../../../assets/icon/topfoottwo_icon_qq.png) no-repeat center #fff
          -webkit-background-size: .34rem .39rem
          background-size: .34rem .39rem
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
        h6
          font-size: .28rem
          color: #000
          font-weight: 700
        p
          font-size: .24rem
          color: #666
      .right
        display: block
        width: 1.54rem
        height: .6rem
        line-height: .6rem
        background-color: #4ebafa
        font-size: .24rem
        color: #fff
        text-align: center
        -webkit-border-radius: .5rem
        -moz-border-radius: .5rem
        border-radius: .5rem
  nav
    position: relative
    left: -.2rem
    width: 7.5rem
    background-color: #fff
    .main
      display: flex
      justify-content: space-around
      align-items: center
      width: 4rem
      height: .9rem
      margin: 0 auto
      a
        display: block
        width: 1.36rem
        height: .52rem
        line-height: .52rem
        border: .02rem solid #e6e6e6
        background-color: #fff
        font-size: .24rem
        color: #666
        text-align: center
  .copyright
    position: relative
    left: -.2rem
    width: 7.5rem
    height: .8rem
    overflow: hidden
    background-color: #fff
    p
      font-size: .28rem
      color: #666
      text-align: center
</style>



// WEBPACK FOOTER //
// src/components/share/footer/topFootThree.vue